jQuery(document).ready(function ($) {
	if (typeof $.fn.featherlight === 'function') {
		$('.video-container').featherlight();
	}
});
